import { useRef, useEffect, RefObject } from 'react';

/**
 * Custom hook to scroll an input field to the start and position cursor at the beginning
 * Useful for long text inputs where you want users to see the start of the text
 *
 * @returns A ref to attach to the input element
 *
 * @example
 * const titleInputRef = useInputScrollToStart<HTMLInputElement>();
 * return <input ref={titleInputRef} ... />
 */
export const useInputScrollToStart = <T extends HTMLInputElement | HTMLTextAreaElement>(): RefObject<T> => {
    const inputRef = useRef<T>(null);

    useEffect(() => {
        if (inputRef.current) {
            // Move cursor to the beginning
            inputRef.current.setSelectionRange(0, 0);
            // Scroll to show the start of the text
            inputRef.current.scrollLeft = 0;
        }
    }, []);

    return inputRef;
};
